module.exports = __webpack_public_path__ + "img/4.e08483b4.jpg";